// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1aA9z","placeholdersHeader":"styles_placeholdersHeader__1yoz2","editorStyle":"styles_editorStyle__3a_wZ","placeholdersBox":"styles_placeholdersBox__Jr3rI"};